import { Icon, Text } from '@blueprint/ui';
import { FC, MouseEvent } from 'react';
import { DesktopFiltersButton, MobileFiltersButton } from './Filters.styles';
import { FiltersModalProps } from './index';

enum LayoutVersion {
    Mobile = 'mobile',
    Desktop = 'desktop'
}

export type FiltersButtonProps = {
    onClick: (evt: MouseEvent<HTMLButtonElement>) => void;
    onKeyDown?: (evt: React.KeyboardEvent<HTMLButtonElement>) => void;
    onKeyUp?: (evt: React.KeyboardEvent<HTMLButtonElement>) => void;
} & Pick<FiltersModalProps, 'version'>;

const buttonCopy = 'Filters';
const defaultHandler = () => null;

export const FiltersButton: FC<FiltersButtonProps> = ({
    version,
    onClick,
    onKeyDown = defaultHandler,
    onKeyUp = defaultHandler
}) => {
    switch (version) {
        case LayoutVersion.Desktop:
            return (
                <DesktopFiltersButton
                    variant="secondary"
                    onClick={onClick}
                    onKeyDown={onKeyDown}
                    onKeyUp={onKeyUp}
                    data-testid="search-results-header_filters-button"
                >
                    <Icon iconId="filters" />
                    <Text isBold={true}>{buttonCopy}</Text>
                </DesktopFiltersButton>
            );

        case LayoutVersion.Mobile:
            return (
                <MobileFiltersButton
                    variant="secondary"
                    onClick={onClick}
                    data-testid="mobile-sub-header_filters-button"
                >
                    <Icon iconId="filters" />
                    <Text isBold={true}>{buttonCopy}</Text>
                </MobileFiltersButton>
            );
        default:
            return null;
    }
};
